import React from "react";
import {createRoot} from "react-dom/client";
import {HashRouter as Router, Routes, Route} from 'react-router-dom';
import App from "./components/App";
import Chat from "./components/Chat";
import News from "./components/News";

const root = createRoot(document.getElementById("root"));
root.render(
    <Router>
        <Routes>
            <Route exact path="/" element={<App/>}/>
            <Route path="/news" element={<News/>}/>
            <Route path="/chat" element={<Chat/>}/>
        </Routes>
    </Router>
);

// textbox filter

/*
<input onChange={(event) => {
    const searchString = event.target.value.toLocaleLowerCase();
    const filteredMonsters = this.state.monsters.filter((monster) => {
        return monster.name.toLocaleLowerCase().includes(searchString);
    });

    // set the state to only filtered monsters. From there, you can render them
    this.setState(() => {
        return {monsters: filteredMonsters};
    });
}}
*/